<template>
    <div>
        <label class="block text-sm text-theme-muted mb-1">Coordenadas</label>
        <div class="flex justify-around items-center">
            <div v-if="itemTemp" class="flex flex-col mx-auto w-10/12">
                <small> Lat : {{ itemTemp.latitude }} </small>
                <small> Lon : {{ itemTemp.longitude }} </small>
            </div>
            <span v-else class="ml-4">Sin ubicación</span>
            <app-button
                icon
                circle
                @click="openLocationModal = !openLocationModal"
            >
                🗺️
            </app-button>
        </div>

        <app-dialog v-model="openLocationModal" size="lg">
            <map-selector
                v-model="itemTemp"
                :enabled="enabled"
                @change="onChange"
            />
        </app-dialog>
    </div>
</template>

<script>
import AppDialog from "@/components/utils/AppDialog.vue";
import MapSelector from "@/components/utils/MapSelector.vue";

export default {
    name: "CoordinatesSelector",
    components: { AppDialog, MapSelector },
    model: { event: "change", prop: "itemCurrent" },
    props: {
        itemCurrent: {
            default: () => ({
                latitude: 4.63082,
                longitude: -74.15035
            }),
            type: Object,
            require: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    data: () => ({
        itemTemp: {
            latitude: 4.63082,
            longitude: -74.15035
        },
        openLocationModal: false
    }),
    watch: {
        itemCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemCurrent);
    },
    methods: {
        onChange(value) {
            this.$emit("change", value);
        },
        setInput(value) {
            this.itemTemp = value;
        }
    }
};
</script>
